module.exports = __webpack_public_path__ + "static/media/arrow-down.00027308.svg";